import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class UserCompanyService {

  private selectedCompanySource: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public currentSelectedCompany = this.selectedCompanySource.asObservable();

  private selectedCompanyCodeSource: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public currentSelectedCompanyCode = this.selectedCompanyCodeSource.asObservable();

  constructor() { }

  public changeSelectedCompany(company: number) {
    this.selectedCompanySource.next(company);
  }

  public get selectedCompanyValue() {
    return this.selectedCompanySource.value;
  }

  public changeSelectedCompanyCode(code: string) {
    this.selectedCompanyCodeSource.next(code);
  }

}
